export const ISEE_PAYWALL_TEST_PROPERTY = "ISEE_Paywall_Test_Q42026";
export const PENDING_ISEE_PAYWALL_TEST_ASSIGNMENT_STORAGE_KEY = "bx_pending_isee_paywall_test_assignment";
export const ISEE_PAYWALL_TEST_EXPOSURE_TRACKED_STORAGE_KEY = "bx_isee_paywall_test_exposure_tracked";

export const MIXPANEL_EXPERIMENT_STARTED_EVENT_NAME = "$experiment_started";
export const MIXPANEL_EXPERIMENT_NAME_PROPERTY = "Experiment name";
export const MIXPANEL_VARIANT_NAME_PROPERTY = "Variant name";
